<form [formGroup]="form">
    <div class="col-12 md:col-12">
        <p-accordion [value]="['0', '1']" [multiple]="true">
            <p-accordion-panel value="0" class="mb-2">
                <p-accordion-header>Datos de residencia</p-accordion-header>
                <p-accordion-content>
                    <div miForm>
                        <div [miCol]="3" miFormField [miFormFieldError]="getErrorMessage('paiRes', 'El país de residencia es requerido')">
                            <label>País de residencia *</label>
                            <p-select
                                [options]="countryList"
                                formControlName="paiRes"
                                placeholder="Seleccione el país de residencia"
                                [style]="{ width: '25rem' }"
                                [filter]="true"
                                [filterBy]="'label,id'"
                                optionLabel="label"
                                optionValue="id"
                                (onChange)="onCountryResChange($event)"
                                appendTo="body"
                            ></p-select>
                        </div>

                        <div [miCol]="3" miFormField [miFormFieldError]="getErrorMessage('ciuRes', 'La ciudad de residencia es requerida')">
                            <label>Ciudad de residencia *</label>
                            <p-select
                                [options]="departmentCitiesResList"
                                formControlName="ciuRes"
                                placeholder="Seleccione la ciudad de residencia"
                                [style]="{ width: '25rem' }"
                                [filter]="true"
                                [filterBy]="'label,id'"
                                optionLabel="label"
                                optionValue="id"
                                appendTo="body"
                            ></p-select>
                        </div>

                        <!-- segundo bloque -->

                        <div [miCol]="3" miFormField [miFormFieldError]="getErrorMessage('barrio', 'El barrio es requerido')    ">
                            <label>Barrio *</label>
                            <input pInputText formControlName="barrio" placeholder="Barrio de residencia" />
                        </div>

                        <div
                            [miCol]="3"
                            miFormField
                            [miFormFieldError]="getErrorMessage('tipoVivienda', 'El tipo de vivienda es requerido')"
                        >
                            <label>Tipo de vivienda *</label>
                            <p-select
                                [options]="tipoViviendaList"
                                formControlName="tipoVivienda"
                                placeholder="Seleccione el tipo de vivienda"
                                [style]="{ width: '25rem' }"
                                [filter]="true"
                                [filterBy]="'label,id'"
                                optionLabel="label"
                                optionValue="id"
                                appendTo="body"
                            ></p-select>
                        </div>

                        <div [miCol]="6" miFormField [miFormFieldError]="getErrorMessage('direccion', 'La dirección es requerida')">
                            <label>Dirección *</label>
                            <input
                                pInputText
                                formControlName="direccion"
                                placeholder="Dirección de residencia"
                                [readOnly]="true"
                                (click)="onDirections()"
                            />
                        </div>
                    </div>
                </p-accordion-content>
            </p-accordion-panel>
            <p-accordion-panel value="1" class="mb-2">
                <p-accordion-header>Datos adicionales</p-accordion-header>
                <p-accordion-content>
                    <div miForm>
                        <div
                            [miCol]="4"
                            miFormField
                            [miFormFieldError]="getErrorMessage('nombreContacto', 'El nombre del contacto de emergencia es requerido')"
                        >
                            <label>Nombre del contacto de emergencia *</label>
                            <input pInputText formControlName="nombreContacto" placeholder="Nombre del contacto de emergencia" />
                        </div>
                        <div [miCol]="4" miFormField [miFormFieldError]="getErrorMessage('direccionContactoEmergencia', 'La dirección es requerida')">
                            <label>Dirección del contacto de emergencia *</label>
                            <input
                                pInputText
                                formControlName="direccionContactoEmergencia"
                                placeholder="Dirección de contacto de emergencia"
                                [readOnly]="true"
                                (click)="onDirectionsContactoEmergencia()"
                            />
                        </div>
                        <div
                            [miCol]="4"
                            miFormField
                            [miFormFieldError]="getErrorMessage('telefonoContacto', 'El teléfono del contacto de emergencia es requerido') "
                        >
                            <label>Teléfono del contacto de emergencia *</label>
                            <p-inputMask
                                id="telefonoContacto"
                                formControlName="telefonoContacto"
                                mask="999 999-9999"
                                placeholder="Teléfono del contacto de emergencia"
                                slotChar=""
                                [unmask]="true"
                            />
                        </div>
                        

                        <div
                            [miCol]="4"
                            miFormField
                            [miFormFieldError]="getErrorMessage('parentesco', 'El parentesco del contacto de emergencia es requerido')"
                        >
                            <label>Parentesco del contacto de emergencia *</label>
                            <p-select
                                [options]="parentescoList"
                                formControlName="parentesco"
                                placeholder="Seleccione el parentesco del contacto de emergencia"
                                [style]="{ width: '25rem' }"
                                [filter]="true"
                                [filterBy]="'label,id'"
                                optionLabel="label"
                                optionValue="id"
                                appendTo="body"
                            ></p-select>
                        </div>

                        <div [miCol]="4" miFormField [miFormFieldError]="getErrorMessage('eps', 'La EPS es requerida')">
                            <label>EPS *</label>
                            <p-select
                                [options]="epsList"
                                formControlName="eps"
                                placeholder="Seleccione la EPS"
                                [style]="{ width: '25rem' }"
                                [filter]="true"
                                [filterBy]="'label,id'"
                                optionLabel="label"
                                optionValue="id"
                                appendTo="body"
                            ></p-select>
                        </div>

                        <div [miCol]="4" miFormField [miFormFieldError]="getErrorMessage('pension', 'El fondo de pensión es requerido')">
                            <label>Fondo de pensión *</label>
                            <p-select
                                [options]="pensionList"
                                formControlName="pension"
                                placeholder="Seleccione el fondo de pensión"
                                [style]="{ width: '25rem' }"
                                [filter]="true"
                                [filterBy]="'label,id'"
                                optionLabel="label"
                                optionValue="id"
                                appendTo="body"
                            ></p-select>
                        </div>

                        <div
                            [miCol]="4"
                            miFormField
                            [miFormFieldError]="getErrorMessage('idNivelSocioEconomico', 'El nivel socioeconómico es requerido')"
                        >
                            <label>Nivel Socioeconómico *</label>
                            <p-select
                                [options]="nivelSocioEcoList"
                                formControlName="idNivelSocioEconomico"
                                placeholder="Seleccione el nivel socioeconómico"
                                [style]="{ width: '25rem' }"
                                [filter]="true"
                                [filterBy]="'label,id'"
                                optionLabel="label"
                                optionValue="id"
                                appendTo="body"
                            ></p-select>
                        </div>

                        <div [miCol]="4" miFormField [miFormFieldError]="getErrorMessage('tallaCamisa', 'La talla de camisa es requerida')">
                            <label>Talla de camisa *</label>
                            <p-select
                                [options]="tallaCamisaList"
                                formControlName="tallaCamisa"
                                placeholder="Seleccione la talla de camisa"
                                [style]="{ width: '25rem' }"
                                [filter]="true"
                                [filterBy]="'label,id'"
                                optionLabel="label"
                                optionValue="id"
                                appendTo="body"
                            ></p-select>
                        </div>

                        <div
                            [miCol]="4"
                            miFormField
                            [miFormFieldError]="getErrorMessage('tallaPantalon', 'La talla de pantalon es requerida')"
                        >
                            <label>Talla de pantalon *</label>
                            <p-select
                                [options]="tallaPantalonList"
                                formControlName="tallaPantalon"
                                placeholder="Seleccione la talla de pantalon"
                                [style]="{ width: '25rem' }"
                                [filter]="true"
                                [filterBy]="'label,id'"
                                optionLabel="label"
                                optionValue="id"
                                appendTo="body"
                            ></p-select>
                        </div>

                        <div [miCol]="4" miFormField [miFormFieldError]="getErrorMessage('tallaZapato', 'La talla de zapato es requerida')">
                            <label>Talla de zapato *</label>
                            <p-select
                                [options]="tallaZapatoList"
                                formControlName="tallaZapato"
                                placeholder="Seleccione la talla de zapato"
                                [style]="{ width: '25rem' }"
                                [filter]="true"
                                [filterBy]="'label,id'"
                                optionLabel="label"
                                optionValue="id"
                                appendTo="body"
                            ></p-select>
                        </div>

                        <div [miCol]="4" miFormField [miFormFieldError]="getErrorMessage('peso', 'El peso es requerido')">
                            <label>Peso *</label>
                            <input pInputText formControlName="peso" placeholder="Peso" />
                        </div>

                        <div [miCol]="4" miFormField [miFormFieldError]="getErrorMessage('estatura', 'La estatura es requerida')">
                            <label>Estatura (cm) *</label>
                            <input pInputText formControlName="estatura" placeholder="Estatura" />
                        </div>

                        <div [miCol]="4" miFormField>
                            <label>¿De dónde obtiene normalmente sus ingresos?</label>
                            <span class="block mb-2 ml-2 text-sm text-gray-500">Seleccione todas las que apliquen *</span>

                            <mat-checkbox formControlName="ingTrabajo">Trabajo o salario</mat-checkbox>
                            <mat-checkbox formControlName="ingOtros">Otros</mat-checkbox>
                        </div>

                        <!-- Campo condicional -->
                        @if (form.get('ingOtros')?.value) {
                            <div [miCol]="4" miFormField>
                                <label for="ingObs">Por favor especifique cuál *</label>
                                <textarea
                                    pTextarea
                                    id="ingObs"
                                    formControlName="ingObs"
                                    placeholder="Tienda online, freelance, inversiones, etc."
                                    rows="4"
                                    cols="30"
                                    [autoResize]="true"
                                >
                                </textarea>
                            </div>
                        }
                    </div>
                </p-accordion-content>
            </p-accordion-panel>
        </p-accordion>
    </div>
</form>
